import { useForm } from "@inertiajs/react";
import { celebrationsPath } from "@travily/routes";
import type CelebrationsNew from "@travily/types/pages/CelebrationsNew";
import type { ReactNode } from "react";
import { useRef } from "react";
import { RoutedModal } from "@/components/RoutedModal";
import { firstError } from "@/lib/forms/first-error";
import { CelebrationModal } from "./new.view";

const CelebrationNewPage = ({ handle }: CelebrationsNew) => {
  const form = useForm({
    body: "",
    celebratable_handle: handle,
  })
    .withPrecognition("post", celebrationsPath())
    .setValidationTimeout(400);

  const formRef = useRef(form);
  formRef.current = form;

  return (
    <RoutedModal size="sm">
      {({ close }) => (
        <CelebrationModal
          body={form.data.body}
          bodyError={form.invalid("body") ? firstError(form.errors.body) : undefined}
          close={close}
          isPending={form.processing}
          onBodyChange={(value) => {
            formRef.current.setData("body", value);
            formRef.current.validate("body");
          }}
          onSubmit={() => {
            formRef.current.post(celebrationsPath(), {
              preserveState: true,
              preserveScroll: true,
              onSuccess: () => close(),
            });
          }}
        />
      )}
    </RoutedModal>
  );
};

CelebrationNewPage.layout = (page: ReactNode) => page;

export default CelebrationNewPage;
